module.exports = __webpack_public_path__ + "d58f65e3267efe8758d2c32153e28c6b.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_pie_show_labels.png
// module id = 891
// module chunks = 7